import PropagateLoader from "react-spinners/PropagateLoader";
export default function SpinnerForm() {
    return (
        <div>
            <main className='flex   mx-3 mt-16 sm:ml-[300px] sm:mt-3'>
                <p>
                    <PropagateLoader
                        color={'#008000'}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </p>
            </main>
        </div>
    );
}